export enum CardTypeV2 {
  Detailed = "detailed",
  Minimal = "minimal",
  Compact = "compact",
  Micro = "micro"
}

export enum DriverInformationValue {
  DriverName = "driverName",
  DriverCode = "driverCode",
  DriverCapabilities = "driverCapabilities",
  DriverCodeAndName = "driverCodeAndName",
  QueuedStopHourglass = "queuedStopHourglass",
  DriverSkills = "driverSkills"
}

export enum StopInformationValue {
  Address = "address",
  AddressAndZone = "addressAndZone",
  CityStateZone = "cityStateZone",
  Zone = "zone",
  ETATime = "etaTime",
  CustomerName = "customerName",
  StopName = "stopName",
  PhoneNumber = "phoneNumber",
  Alias = "alias",
  TotalPieces = "totalPieces",
  InvoiceReference = "invoiceReference",
  ServiceType = "serviceType",
  JobNumber = "jobNumber",
  Auth = "auth",
  RouteNumber = "routeNumber"
}

export enum TopStopInformationValue {
  LastCompletedStop = "LastCompletedStop",
  NextStopInManifest = "NextStopInManifest",
  FirstStopInManifest = "FirstStopInManifest"
}

export enum HoverOnDriversValues {
  DRIVER_PHONE = "Driver Phone",
  ALIAS = "Alias",
  MANIFEST_ID = "Manifest ID",
  MANIFEST_DATE = "Manifest Date",
  LAST_ZONE = "Last Zone",
  NOTES = "Notes",
  END_ZIP = "End Zip",
  DRIVER_CODE = "Driver Code",
  DRIVER_NAME = "Driver Name",
  DRIVER_CAPABILITIES = "Driver Capabilities"
}
export enum HoverOnStopsValues {
  STOP_ADDRESS = "Stop Address",
  CUSTOMER = "Customer",
  STOP_SEE = "Stop See",
  STOP_PHONE = "Stop Phone",
  ROUTE_NUMBER = "Route #",
  SERVICE = "Service",
  STOP_NAME = "Stop Name",
  STOP_NOTES = "Stop Notes",
  PIECES_OR_WEIGHT = "Pieces / Weight",
  STOP_ROOM = "Stop Room",
  DESCRIPTION = "Description",
  CALLER_AND_PHONE = "Caller and phone",
  AUTH = "Auth",
  // DP-3156: the value is the identifier persisted in the manifestCardConfigurations
  // preference — it must stay "Alias". Only the displayed label becomes "Order Alias",
  // via HOVER_ON_STOPS_LABELS in ./constants.
  ALIAS = "Alias",
  JOB_ALIAS = "Job Alias",
  COD_STATUS_AND_AMOUNT = "COD Status and COD Amount",
  OTHER_REFERENCE = "Other Reference",
  INVOICE_REFERENCE = "Invoice Reference",
  JOB_NUMBER = "Job Number"
}
